<div class="workflow-create-dialog-container">
  <!-- Modal Header -->
  <div class="modal-header">
    <h2 class="modal-title">New Workflow</h2>
    <button
      mat-icon-button
      class="close-button"
      (click)="onCancel()"
      [disabled]="isCreating()"
      aria-label="Close"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Modal Content -->
  <div mat-dialog-content class="dialog-content">
    <p class="dialog-subtitle">Fill the workflow information:</p>
    <form
      [formGroup]="workflowForm"
      (ngSubmit)="onSubmit()"
      class="workflow-form"
    >
      <!-- Workflow Name Field -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Workflow Name</mat-label>
        <input
          matInput
          formControlName="name"
          placeholder="Enter workflow name"
          maxlength="100"
        />
        <mat-hint align="end"
          >{{ nameControl?.value?.length || 0 }}/100</mat-hint
        >
        @if (isNameInvalid) {
          <mat-error>
            {{ nameErrorMessage }}
          </mat-error>
        }
      </mat-form-field>

      <!-- Step Name Field -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Step Name</mat-label>
        <input
          matInput
          formControlName="chunkName"
          placeholder="Enter step name"
          maxlength="100"
        />
        <mat-hint align="end"
          >{{ chunkNameControl?.value?.length || 0 }}/100</mat-hint
        >
        @if (isChunkNameInvalid) {
          <mat-error>
            {{ chunkNameErrorMessage }}
          </mat-error>
        }
      </mat-form-field>

      <!-- Step Type Field -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Step type</mat-label>
        <mat-select
          [formControlName]="
            stepTypes().length > 0 ? 'stepTypeId' : 'chunkTypeId'
          "
        >
          @if (isLoadingStepTypes() || isLoadingChunkTypes()) {
            <mat-option disabled> Loading step types... </mat-option>
          }
          @for (stepType of getAvailableTypes(); track stepType.steptypeId) {
            <mat-option [value]="getTypeId(stepType)">
              {{ stepType.name }}
            </mat-option>
          }
        </mat-select>
        @if (isStepTypeInvalid) {
          <mat-error>
            {{ stepTypeErrorMessage }}
          </mat-error>
        }
      </mat-form-field>
    </form>
  </div>

  <!-- Modal Actions -->
  <div mat-dialog-actions class="dialog-actions">
    <button
      class="cancel-button"
      type="button"
      (click)="onCancel()"
      [disabled]="isCreating()"
    >
      Cancel
    </button>

    <button
      class="create-button"
      type="submit"
      (click)="onSubmit()"
      [disabled]="
        workflowForm.invalid ||
        isCreating() ||
        isLoadingStepTypes() ||
        isLoadingChunkTypes()
      "
    >
      @if (isCreating()) {
        <mat-spinner diameter="18" class="spinner"></mat-spinner>
      }
      @if (!isCreating()) {
        <span>Create</span>
      }
      @if (isCreating()) {
        <span>Creating...</span>
      }
    </button>
  </div>
</div>
